import dynamic from 'next/dynamic'
import { DemographicsIcon } from 'src/components/insights/icons/demographics'
import { InsightBuilderWidget } from 'src/types/insight-builder'
import preview from 'src/assets/images/widgets-previews/population.png'

const DemographicsPopulation = dynamic(() => import('src/components/insights/demographics/cards/population'), {
  ssr: false,
})

export const DemographicsPopulationWidget: InsightBuilderWidget = {
  id: 'population',
  name: 'Population',
  type: 'Demographics',
  icon: DemographicsIcon,
  component: DemographicsPopulation,
  supportedResultTypes: ['alphamap-location'],
  preview,
}
